import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

const { foundations } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  dialogTitle: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  closeButton: { marginLeft: '8px', '& .MuiSvgIcon-root': { marginRight: '0px' } },
  dialogPaper: { margin: 'auto' },
  dialogContent: {},
  formLabel: { marginBottom: '4px', fontSize: '16px', fontWeight: foundations.typography.fontWeight.medium },
  textField: { width: '100%', '& .MuiInputBase-root.MuiOutlinedInput-root': { margin: 0 } },
  dialogActions: { justifyContent: 'flex-end', gap: '8px', padding: '16px 24px' },
});
